import { render, staticRenderFns } from "./issueinfo.vue?vue&type=template&id=2351bd49&scoped=true&"
import script from "./issueinfo.vue?vue&type=script&lang=js&"
export * from "./issueinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2351bd49",
  null
  
)

export default component.exports